// extracted by mini-css-extract-plugin
module.exports = {"container":"NavList_container__2BFDq","visuallyHidden":"NavList_visuallyHidden__1kGC3","list_nav":"NavList_list_nav__fKVDk"};